import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "riskWarningMessage",
  class: "risk-warning mt-4",
  style: {}
}
const _hoisted_2 = { id: "pensionsReturnRiskMsgVal" }
const _hoisted_3 = { id: "savingsReturnRiskMsgVal" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "risk-warning mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_risk_selector = _resolveComponent("risk-selector")!
  const _component_sub_section = _resolveComponent("sub-section")!

  return (_openBlock(), _createBlock(_component_sub_section, {
    title: "Choose the annual growth rate on your investments",
    helpTitle: "Growth projections",
    helpText: _ctx.HelpText.growthProjections(),
    showHelp: _ctx.showRiskHelp
  }, {
    default: _withCtx(() => [
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-0" }, "On investments in your defined contribution pension pots", -1)),
      _createVNode(_component_risk_selector, {
        ref: "pensionRiskSelector",
        key: "pensionRiskSelector",
        mode: "Pensions",
        "aria-label": " the amount of risk you are willing to take on investments in your defined contribution pension pots by 0.5%"
      }, null, 512),
      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "mb-0 mt-4" }, "On investments in your savings pots", -1)),
      _createVNode(_component_risk_selector, {
        ref: "savingsRiskSelector",
        key: "savingsRiskSelector",
        mode: "Savings",
        "aria-label": " the amount of risk you are willing to take on investments in your savings pots by 0.5%"
      }, null, 512),
      (_ctx.showRateText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
            _cache[2] || (_cache[2] = _createTextVNode(" You have chosen to use estimated annual growth of ")),
            _createElementVNode("strong", null, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.pensionsReturnRate), 1),
              _cache[0] || (_cache[0] = _createTextVNode("%"))
            ]),
            _cache[3] || (_cache[3] = _createTextVNode(" on your defined contribution pension pots and ")),
            _createElementVNode("strong", null, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.savingsReturnRate), 1),
              _cache[1] || (_cache[1] = _createTextVNode("%"))
            ]),
            _cache[4] || (_cache[4] = _createTextVNode(" on your savings pots. ")),
            _createElementVNode("span", {
              innerHTML: _ctx.riskBasedOnText()
            }, null, 8, _hoisted_4)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, " There will always be some risk involved in accessing your pension using the pension freedoms. If you want to take no risk at all a guaranteed income for life (annuity) may be a better choice. "))
    ]),
    _: 1
  }, 8, ["helpText", "showHelp"]))
}